module.exports = __webpack_public_path__ + "img/ep-1.5ecafaf1.jpg";